import { array, string } from 'yup'
import { safify } from '../utils/safify'

export const palette = array().of(string()).default([]).meta({ autoFill: false }).transform(safify)
